import * as React from 'react';
import PlusOutlined from './plus-outlined';
import PlusFilled from './plus-filled';
import type { IconCombinedProps } from './types';
const PlusCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <PlusFilled ref={ref} {...rest} />;
  }
  return <PlusOutlined ref={ref} {...rest} />;
});
export default PlusCombined;